import styled from 'styled-components';

export const Container = styled.div<{ timeContainer?: boolean }>`
  font-family: 'Source Sans Pro';
  display: flex;
  flex-direction: column;
  gap: ${({ timeContainer }) => (timeContainer ? '0.75' : '1.5')}rem;
  background-color: ${({ theme }) => theme.colors.white};
  padding: ${({ timeContainer }) =>
    timeContainer ? '1.5rem 1.5rem' : '2rem 1.5rem'};
  margin-top: ${({ timeContainer }) => (timeContainer ? '0.75' : '0.5')}rem;

  ${({ timeContainer }) =>
    timeContainer &&
    `
    .hefesto-progress {
      width: 270px;
      }
      
    .hefesto-progress__label {
      display: none;  
    }
  `};
`;
export const TooltipContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`;

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.gray8};
`;

export const InputWrapper = styled.div<{
  table?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: ${({ table }) => (table ? '0' : '1.5 0')}rem;
  height: ${({ table }) => (table ? '2.50' : '3rem')}rem;

  & > div {
    width: ${({ table }) => (table ? '3.25' : '29.13')}rem;
  }
`;

export const OrderInputWrapper = styled.div`
  position: relative;
`;

export const OrderNameWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 1.5rem;
  margin-bottom: 3rem;
  width: 29.13rem;
  .hefesto-tooltip {
    padding: 100px !important;
  }
`;

export const OrderItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const OrderValuesContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ItemText = styled.span<{
  bold?: boolean;
  isTitle?: boolean;
  error?: boolean;
}>`
  font-family: ${({ isTitle }) => (isTitle ? 'Source Sans Pro' : 'Work Sans')};
  font-weight: ${({ bold, isTitle }) => (bold || isTitle ? '600' : '400')};
  font-size: ${({ isTitle }) => (isTitle ? '1.5' : '1')}rem;
  line-height: ${({ isTitle }) => (isTitle ? '2' : '1.5')}rem;
  color: ${({ theme, isTitle, error }) => {
    if (isTitle) {
      return theme.colors.grayDark3;
    }

    if (error) {
      return '#B84232';
    }

    return theme.colors.grayDark4;
  }};
`;

export const OrderDetailsValuesContainer = styled.div<{
  smallerMarginTop: boolean;
}>`
  margin-top: ${({ smallerMarginTop }) =>
    smallerMarginTop ? '1rem' : '1.5rem'};
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem 1.5rem;
  flex-wrap: wrap;
  @media (max-width: 1199px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.laptopM}) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const TableContainer = styled.div`
  font-family: 'Source Sans Pro';
  padding: 1rem 1.5rem;
  gap: 1rem;
  display: flex;
  flex-direction: column;

  & > div {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .hefesto-tag {
    width: 100%;
  }
`;

export const BottomContainer = styled.div<{ littleContent?: boolean }>`
  background: ${({ theme }) => theme.colors.white};

  display: flex;
  justify-content: space-between;

  padding: 1.5rem;
  gap: 1.5rem;
  min-height: 6rem;

  position: sticky;
  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    position: ${({ littleContent }) => (littleContent ? 'fixed' : 'sticky')};
  }
  width: -webkit-fill-available;
  bottom: 0;
  left: 0;

  z-index: 99;

  box-shadow: ${({ theme }) => theme.commoms.boxShadow2};
  @media (max-width: ${({ theme }) => theme.breakpoints.laptopM}) {
    flex-direction: column;
  }
`;

export const BottomSummary = styled.div`
  display: flex;
  flex-direction: column;
`;

export const BottomButtons = styled.div`
  display: flex;
  gap: 1.5rem;

  align-items: center;

  & > button {
    width: 16.88rem;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.laptopM}) {
    justify-content: space-between;
  }
`;

export const Divider = styled.div`
  height: 1px;
  width: 100%;
  background-color: #efefef;
  margin: 1rem 0;
`;

export const ContainerErrorTaxs = styled.div``;
export const ContainerErrorTextTaxs = styled.div`
  display: flex;
  gap: 0.5rem;
`;
export const SpanErrorTaxs = styled.span`
  color: #b84232;
`;
export const SpanRetryTaxs = styled.span`
  color: ${({ theme }) => theme.colors.blue6};
  font-weight: 700;
  font-style: Bold;
  text-decoration: underline;
  cursor: pointer;
`;
export const SpanObsTaxs = styled.span``;

export const ReceiverSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1.5rem;
`;

export const ReceiverSectionTitle = styled.span`
  font-family: 'Source Sans Pro';
  font-weight: 600;
  font-size: 1.5rem;
  line-height: 2rem;
  color: ${({ theme }) => theme.colors.grayDark3};
`;

export const ReceiverAddressBox = styled.div`
  background-color: #ecf2f6;
  border-radius: 4px;
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

export const ReceiverAddressLabel = styled.span`
  font-family: 'Source Sans 3', 'Source Sans Pro', Arial, Helvetica, sans-serif;
  font-weight: 400;
  font-size: 20px;
  line-height: 1.75rem;
  color: ${({ theme }) => theme.colors.grayDark4};
`;

export const ReceiverAddressValue = styled.span`
  font-family: 'Work Sans';
  font-weight: 600;
  font-size: 1rem;
  line-height: 1.5rem;
  color: ${({ theme }) => theme.colors.grayDark4};
`;

export const SkeletonContainer = styled.div`
  margin-top: 1rem;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
`;
